import Button from '@components/V4/Button';
import Table from '@components/V4/Table/Table';
import { PaginationProps } from '@components/V4/Pagination';
import Tooltip from '@components/V4/Tooltip';
import { ParentFeedbackEntry } from './types';
import moment from 'moment';

interface Props {
  entries?: ParentFeedbackEntry[];
  isLoading: boolean;
  pagination: PaginationProps;
  onViewSession: (sessionId: string) => void;
}

const SessionParentFeedbackTable = ({ entries, isLoading, pagination, onViewSession }: Props) => {
  const rows =
    entries?.flatMap((entry) =>
      (entry.sessionParentFeedback ?? [])
        .filter((feedback) => typeof feedback?.parentFeedback?.rating === 'number')
        .map((feedback, index) => ({
          id: `${entry._id}-${feedback.sessionId ?? index}`,
          entry,
          feedback,
        }))
    ) ?? [];

  return (
    <Table isLoading={isLoading} isUserView pagination={pagination} className="w-full">
      <Table.Header>
        <Table.Row isHeader>
          <Table.HeaderCell>Student</Table.HeaderCell>
          <Table.HeaderCell>Course</Table.HeaderCell>
          <Table.HeaderCell>Session</Table.HeaderCell>
          <Table.HeaderCell>Submitted</Table.HeaderCell>
          <Table.HeaderCell>Rating</Table.HeaderCell>
          <Table.HeaderCell>Message</Table.HeaderCell>
          <Table.HeaderCell>Actions</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body hasResults={!isLoading && !!rows.length}>
        {rows.map(({ entry, feedback }) => (
          <Table.Row key={feedback.sessionId}>
            <Table.Cell>{entry.student?.name ?? 'n/a'}</Table.Cell>
            <Table.Cell>{entry.course?.title ?? 'n/a'}</Table.Cell>
            <Table.Cell>{feedback.sessionName ?? 'n/a'}</Table.Cell>
            <Table.Cell>
              {feedback.parentFeedback?.createdAt
                ? moment(feedback.parentFeedback.createdAt).format('DD.MM.YYYY')
                : 'n/a'}
            </Table.Cell>
            <Table.Cell>{feedback.parentFeedback?.rating ?? 'n/a'}</Table.Cell>
            <Table.Cell className="max-w-80">
              <Tooltip text={feedback.parentFeedback?.message}>
                <span className="line-clamp-2">
                  {feedback.parentFeedback?.message || <span className="text-customGrey">n/a</span>}
                </span>
              </Tooltip>
            </Table.Cell>
            <Table.Cell>
              <Button
                variant="secondary"
                buttonText="View"
                disabled={!feedback.sessionId}
                onClick={() => {
                  if (feedback.sessionId) {
                    onViewSession(feedback.sessionId);
                  }
                }}
              />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default SessionParentFeedbackTable;
